import type { InputPuzzle } from "./puzzle.types";

export const PROFESSIONAL_PUZZLES: InputPuzzle[] = [
  {
    p: "120054000470000308500003000001700060000060040000000000069200530000300700000005004",
    s: "123854976476192358598673412941738265782569143635421897869247531254316789317985624",
    d: -2767,
  },
  {
    p: "000000090009420013470000006000010060006000500050340208060000030012000000800001002",
    s: "123867495689425713475193826748512369236978541951346278567289134312654987894731652",
    d: -2862,
  },
  {
    p: "023006580095000304400000600000020730000001000060097040036005009000604000700080000",
    s: "123946587695872314487153692941528736372461958568397241836715429219634875754289163",
    d: -2555,
  },
  {
    p: "005060000060000000000001280000000520092000000070805019000684701003170000004900000",
    s: "125768493368249175947531286831496527592317648476825319259684731683172954714953862",
    d: -2862,
  },
  {
    p: "000400090000200051500001600000035284009008007000002000602000800010300700030700006",
    s: "126457398897263451543891672761935284259648137384172965672519843415386729938724516",
    d: -2468,
  },
  {
    p: "100400059040300001830010007060803705400002030000900000580030070000000210010007008",
    s: "126478359947325681835619427261843795498752136753961842582136974679584213314297568",
    d: -2745,
  },
  {
    p: "100530000000200010000040602047000000090010758000080009500300080200008000700950001",
    s: "126537894478269315953841672847695123692413758315782469561324987239178546784956231",
    d: -2468,
  },
  {
    p: "100040800700800060504026900000008400008039007040700600030000740000000002602000050",
    s: "126947835793851264584326971917568423268439517345712698831295746459673182672184359",
    d: -2555,
  },
  {
    p: "020460000000907000895010000000004900906000000400008600700000028004200000300000140",
    s: "127465893643987251895312476238654917976123584451798632719546328584231769362879145",
    d: -2767,
  },
  {
    p: "000850649000471008000009000200007300010620400000005001000904080080000007900000000",
    s: "127853649693471258845269713258147396319628475764395821576934182482516937931782564",
    d: -2862,
  },
  {
    p: "100900040030070006000000000281000050000580094009700003000004069000120000070050000",
    s: "127968345834275916695341872281493657763582194459716283512834769946127538378659421",
    d: -2767,
  },
  {
    p: "009000040800400002030000000040039000900104000000026800092500070500060209703008050",
    s: "129683547876415932435972681247839165968154723351726894692541378584367219713298456",
    d: -2555,
  },
  {
    p: "020000450060000000000040003000100000805002030042050071000000090001008000900003647",
    s: "129837456364521789587946213793184562815762934642359871236475198471698325958213647",
    d: -2767,
  },
  {
    p: "100049006040000050900000000703800920000012000014500300060000000090008100300900002",
    s: "135249786847136259926785413753864921689312574214597368561423897492678135378951642",
    d: -2862,
  },
  {
    p: "030400780900050000064030000208007045001000020070000609307009001000000000009100000",
    s: "135492786982756134764831952298617345651943827473528619347289561516374298829165473",
    d: -2862,
  },
  {
    p: "035009000860100000000460000000903865000006900700000000000000000517080009409000002",
    s: "135729486864135297972468153241973865358246971796851324623594718517382649489617532",
    d: -2767,
  },
  {
    p: "000000600000400000006200379070001900008020407500098000350104000000000803004060700",
    s: "135879624729436581486215379672541938918623457543798162357184296261957843894362715",
    d: -2961,
  },
  {
    p: "130000000002000001008000304000080040090000000057100026360050000000040000400600512",
    s: "136498257542367891978512364213986745694725183857134926361259478725841639489673512",
    d: -2767,
  },
  {
    p: "000000002500610000040200006790000240600300057080000009207000030000029008860000004",
    s: "136947582572618493948253176793865241621394857485172369217486935354729618869531724",
    d: -2961,
  },
  {
    p: "037600489000700000005041007000000800000000906060309024059100048006000215040002600",
    s: "137625489684793152925841367592467831413258976768319524259136748376984215841572693",
    d: -2958,
  },
  {
    p: "138000000000075800905001006069020100004856300800093000000009640000030709400000080",
    s: "138642975642975831975381426369724158214856397857193264783519642526438719491267583",
    d: -2848,
  },
  {
    p: "002085700000607000000100000400001007267504000001000090518700430030010506900003001",
    s: "142985763895637142673142985489361257267594318351278694518726439734819526926453871",
    d: -2848,
  },
  {
    p: "040708000900000000205603001006100507400050800300002000000000090600000700500320000",
    s: "143798652968215374275643981896134527427956813351872469734561298612489735589327146",
    d: -2767,
  },
  {
    p: "000080070008900046206000800080700000000000694501040080000107402010300008070804005",
    s: "145683279738952146296471853984736521327518694561249387859167432412395768673824915",
    d: -2745,
  },
  {
    p: "005000020600090000900030100409750006708003410030006000000610503070000000001000000",
    s: "145867329683291754927534168419758236768923415532146897894612573276385941351479682",
    d: -2862,
  },
  {
    p: "000002800700300000000000010250060970601000000070410002300006500010000400009070080",
    s: "146752839785391264932684715254863971691527348873419652328146597517938426469275183",
    d: -2767,
  },
  {
    p: "100700095030010000058300070070690800000000200000005036000000020400803001000040700",
    s: "146782395732519648958364172273691854569438217814275936681957423497823561325146789",
    d: -2862,
  },
  {
    p: "006030000075600034030001009001806000408090050000050083700069000200000040000007006",
    s: "146935872975682134832471569351826497428793651697154283714569328269318745583247916",
    d: -2555,
  },
  {
    p: "047000000800000607060500019000900805034000000700620300400000500250100090006008000",
    s: "147369258895214637362587419621943875534871962789625341413792586258136794976458123",
    d: -2961,
  },
  {
    p: "100500003000014070300000640926070500708030406010000000800050000000000390060090000",
    s: "147569283682314975395728641926471538758932416413685729839257164571846392264193857",
    d: -2961,
  },
  {
    p: "100600350000004210000000009006001080800009400030000902000000000294300100300080500",
    s: "149628357783594216652713849926431785875269431431875962518947623294356178367182594",
    d: -2862,
  },
  {
    p: "050004700006002000080060050937000000800500040000700600000010009009000084520086100",
    s: "152894736796352418483167952937641825861529347245738691378415269619273584524986173",
    d: -2468,
  },
  {
    p: "003000049700800605800000003080007000030108000600005000001700590000000020406350700",
    s: "153276849742893615869541273985437162234168957617925438321784596578619324496352781",
    d: -2468,
  },
  {
    p: "050480006802006000004100003016000230029500000500000000000700001001005000000802740",
    s: "153487926892356417764129853416978235329564178587231694248793561971645382635812749",
    d: -2468,
  },
  {
    p: "000620007000309200000000005006080000007062000500700100700830009802070006000090040",
    s: "153628497674359281928417635236185974417962853589743162741836529892574316365291748",
    d: -2862,
  },
  {
    p: "058003000006008000900002010070600051000020009000030720700000800000009600209700005",
    s: "158973264426158973937462518872694351613527489594831726761345892385219647249786135",
    d: -2862,
  },
  {
    p: "000463000360075009270100000000309076630040000001680230003000020800001057710000000",
    s: "159463782368275149274198365482319576637542918591687234943756821826931457715824693",
    d: -2958,
  },
  {
    p: "102005400000000000700049020000570009000004160600008004010763000040000080000000002",
    s: "162835497894627513735149826481576239573294168629318754218763945347952681956481372",
    d: -2767,
  },
  {
    p: "060970050040360002005000000300010207700086100080000600000001003094000000000700000",
    s: "162974358847365912935128476356419287729586134481237695278691543694853721513742869",
    d: -2767,
  },
  {
    p: "000000009005801000004065030730000050010000608000009000907300840000000025080002003",
    s: "163724589295831476874965132739618254412573698658249317927356841346187925581492763",
    d: -2862,
  },
  {
    p: "060050007000000000005102000300060070680791000490000000000003400800014030230000000",
    s: "163859247928647513745132869351468972682791354497325186516973428879214635234586791",
    d: -2767,
  },
  {
    p: "000900205000500061900010730490250803000789500708030029231040000009000002004092000",
    s: "163974285847523961925618734496251873312789546758436129231845697589367412674192358",
    d: -2661,
  },
  {
    p: "064083070827000006000602000200100900908420000510097000080060304000000020090005001",
    s: "164583279827914536359672418243158967978426153516397842785261394631849725492735681",
    d: -2848,
  },
  {
    p: "060800204000001000900005800006213000018400067000000000000392005400080029000000030",
    s: "165837294384921576927645813746213958218459367539768142671392485453186729892574631",
    d: -2468,
  },
  {
    p: "000400200023050098000060007000000300600201050050070004006000570030000000270905400",
    s: "167498235423157698895362147719584326684231759352679814946823571531746982278915463",
    d: -2961,
  },
  {
    p: "100002030040080020000000009020309060070100000001070800000001007006730000000400280",
    s: "167942538943587126852613479428359761579168342631274895394821657286735914715496283",
    d: -2767,
  },
  {
    p: "100030070005001600400960000930000000000006000720400015080004000002500003309020000",
    s: "168235974295741638473968152931852467854176329726493815587314296612589743349627581",
    d: -2862,
  },
  {
    p: "060040080070008000000000000400700038780000106000005700000001340940002000003800501",
    s: "169547283574238619238619475415726938782493156396185724857961342941352867623874591",
    d: -2862,
  },
  {
    p: "000003002007000409080209001006500000050000127090000000310006004902054000005070000",
    s: "169743852237185469584269731826517943453698127791432685318926574972854316645371298",
    d: -2468,
  },
  {
    p: "000006008084000900003000010700800041020100050300000000040000060605920400809000700",
    s: "172496538584213976963578214796852341428139657351764892247385169615927483839641725",
    d: -2862,
  },
  {
    p: "000003000068009073050020168034000000705300640800000031600000097200930800000700004",
    s: "172863459468159273359427168934612785715398642826574931683241597247935816591786324",
    d: -2848,
  },
  {
    p: "000002050509080000000701030800300200005060009000000570300007860000000000050008310",
    s: "173942658549683721628751934891375246735264189462819573314597862287136495956428317",
    d: -2767,
  },
  {
    p: "000056000805419020002000000060308900000090000400002100000860012000900060010000030",
    s: "174256398835419627692783451261348975387195246459672183943867512528931764716524839",
    d: -2862,
  },
  {
    p: "000020009000605020050700038000006305500100002400030600009007000000300000006009401",
    s: "174823569938615724652794138827946315563178942491532687219467853745381296386259471",
    d: -2862,
  },
  {
    p: "070290000020605000038100200709020540460000009000000010006000900000548002000030000",
    s: "175293684924685731638174295789321546461857329253469817846712953397548162512936478",
    d: -2961,
  },
  {
    p: "000600000030009000890507002903002000000001000250008361020080130007000008000006500",
    s: "175624983432819756896537412913462875768351249254978361629785134547193628381246597",
    d: -2468,
  },
  {
    p: "000000600000700000240500000009102000800970000706008200060005000901200060050000379",
    s: "175829643693714852248563917539142786824976531716358294367495128981237465452681379",
    d: -2862,
  },
  {
    p: "005069030002000008080240005000300400008470526700000000000000900096023007040000000",
    s: "175869234462135798389247615621358479938471526754692381513784962896523147247916853",
    d: -2961,
  },
  {
    p: "000308005000029607004700000721400500600000000000000230030094000000000870000803000",
    s: "176348925385129647294765381721436598653982714948517236837694152469251873512873469",
    d: -2767,
  },
  {
    p: "070000004802000000400060900007500400005801300004730098000000023069000070000000100",
    s: "176389254892154736453267981387596412925841367614732598541978623269413875738625149",
    d: -2862,
  },
  {
    p: "000405000000000516000000700600000201300809000009000060800026050005010024001003009",
    s: "176485932498237516253691748687354291312869475549172863834926157965718324721543689",
    d: -2862,
  },
  {
    p: "076054000520000010004009050400008300003940060000520000000002031930001426241005700",
    s: "176854293529376814384219657492168375853947162617523948768492531935781426241635789",
    d: -2557,
  },
  {
    p: "000946530650030090000800000010000005700025800503410006000000927900000000207000184",
    s: "178946532654132798329857461812769345746325819593418276435681927981274653267593184",
    d: -2848,
  },
  {
    p: "000004600308905700040000000450000020080070000003000560900030800200009003000020040",
    s: "179284635328965714546317289451698327682573491793142568917436852264859173835721946",
    d: -2767,
  },
  {
    p: "080400503030080410057900020001670040000000000700004200010000000896021004274398160",
    s: "182467593639285417457913826521679348943852671768134259315746982896521734274398165",
    d: -2661,
  },
  {
    p: "002009006000007800034801002000700408000050900900000217805000070010000000020030000",
    s: "182549736596327841734861592261793458478152963953684217845216379319478625627935184",
    d: -2862,
  },
  {
    p: "000035090070001600000000082501200000908050706006000023065004200000008000000090000",
    s: "182635497479821635653947182531276948928453716746189523865314279294768351317592864",
    d: -2862,
  },
  {
    p: "084350000000007300006001582070500060000006030002800074000018900000000020409000000",
    s: "184352697295687341736941582371524869948176235562839174627418953813795426459263718",
    d: -2961,
  },
  {
    p: "004350900600200000000070063051400020027801500040000009000000006000000080500032100",
    s: "184356972673249851295178463351497628927861534846523719412785396739614285568932147",
    d: -2468,
  },
  {
    p: "000690000600010004327000000000007900200080406008000700069000207010800000840000300",
    s: "184692573695713824327458169456237918271985436938164752569341287713829645842576391",
    d: -2862,
  },
  {
    p: "084006002050008040302010007060000724003500000070080300000034800607000000000000010",
    s: "184976532756328941392415687865193724923547168471682359519234876647851293238769415",
    d: -2468,
  },
  {
    p: "000000007900746850700810030002907000607001203030060000500003004000100020216000085",
    s: "185392467923746851764815932452937618697581243831264579578623194349158726216479385",
    d: -2958,
  },
  {
    p: "085000079040000102600010800030050060001000290000700000570630900090080520002579030",
    s: "185423679943867152627915843439251768761348295258796314574632981396184527812579436",
    d: -2958,
  },
  {
    p: "100000237690203500300000406001056002000842005000010000000030709760400000503000080",
    s: "185964237694273518372581496841356972937842165256719843418635729769428351523197684",
    d: -2848,
  },
  {
    p: "006027000003000870004080106009001640710405900000000010000052000030100087021003009",
    s: "186527394593614872274389156359271648718465923642938715967852431435196287821743569",
    d: -2848,
  },
  {
    p: "007000000360100000020040000690017005000009300008005170000070500840900060079060030",
    s: "187536942364192758925748613692317485751489326438625179216873594843951267579264831",
    d: -2555,
  },
  {
    p: "007000020905400700002130500800006030610702000000000000000004075200050004000000810",
    s: "187965423935428761462137589824596137613742958759813246391284675278651394546379812",
    d: -2862,
  },
  {
    p: "009000052700000300020007016000506004003980020000074800602340009000690000000000000",
    s: "189463752756129348324857916278536194543981627961274835612348579437695281895712463",
    d: -2468,
  },
  {
    p: "000700002050090300600024059010482005000003000000500700000800074001050030008001000",
    s: "189735462254698317637124859713482695546973281892516743325869174461257938978341526",
    d: -2468,
  },
  {
    p: "180006000007030806000420000004300100000000000600015040000900030000560008460002090",
    s: "189756324247139856356428917524387169731694285698215743875941632912563478463872591",
    d: -2862,
  },
  {
    p: "000000000602800000000001703000000000031009000040176800300480610900005000000200000",
    s: "193752486672834951458961723567328194831549267249176835325487619984615372716293548",
    d: -2591,
  },
  {
    p: "004000020000090010030156000071000060200000700005009000400030000300020800810570000",
    s: "194387625568492317732156489971243568243865791685719243427938156359621874816574932",
    d: -2767,
  },
  {
    p: "000000870000810000000009000640000500012600007000240001001070905060450002507000600",
    s: "194523876376814259285769143643197528812635497759248361421376985968451732537982614",
    d: -2468,
  },
  {
    p: "004008003000700000000002080607090000200000730900080005701960004000400008030001090",
    s: "194658273862739451375142986657394812248516739913287645781965324529473168436821597",
    d: -2862,
  },
  {
    p: "095000600087500010000100270458000000010005923900000000000319800000000000000600507",
    s: "195273684287546319364198275458932761716485923923761458572319846649857132831624597",
    d: -2468,
  },
  {
    p: "000640002604027090078090006006000040742035080800700003507319064000000900000050020",
    s: "195648372634127598278593416356281749742935681819764253527319864461872935983456127",
    d: -2557,
  },
  {
    p: "000740608030809010040300002800203000001000000000400000002060004900000706000000095",
    s: "195742638236859417748316952869273541421695873573481269352967184914538726687124395",
    d: -2767,
  },
  {
    p: "190000200000052000007004005704096000012500000000030000401070000308040970900000400",
    s: "195863247843752169267914835734296518612587394589431726451379682328645971976128453",
    d: -2961,
  },
  {
    p: "090020053084003000200000081730064100609300000002000008000476000060000020000000900",
    s: "196827453584613279273945681738564192619382547452791368921476835865139724347258916",
    d: -2961,
  },
  {
    p: "100045000008300090005100080040906000007010020020070065009600007650000030000000000",
    s: "196845372478362591235197684543926718967518423821473965389651247652784139714239856",
    d: -2862,
  },
  {
    p: "096007050020100900058000060010000800640280700307000006000001002031050070070029000",
    s: "196847253723165948458392167912576834645283791387914526569731482231458679874629315",
    d: -2745,
  },
  {
    p: "100830005054000000060000030012900600600400009000302007480200000000010000029005000",
    s: "197834265354126978268579134812957643673481529945362817481293756536718492729645381",
    d: -2862,
  },
  {
    p: "100000030260007100008025700089000004003010870000750000000900000470002000000030000",
    s: "197846235265397148348125769789263514523419876614758923831974652476582391952631487",
    d: -2767,
  },
  {
    p: "097000200006000000000090003012030050070004000603001002000250030304700080950008000",
    s: "197863245236475891485192763812937456579624318643581972768259134324716589951348627",
    d: -2468,
  },
  {
    p: "008003540070002090002910008536004000000000680010009004000740000000000810020000000",
    s: "198673542375482196462915738536824971249137685817569324683741259754296813921358467",
    d: -2862,
  },
  {
    p: "090040500000000000260809010000050007050100698809000400030070050004200000700000001",
    s: "198742563473615289265839714642958137357124698819367425931476852584291376726583941",
    d: -2862,
  },
  {
    p: "003000905800907010007010003002600000900000504045370006000004000000023401000000000",
    s: "213468975854937612697512843382645197976281534145379286521794368769823451438156729",
    d: -2862,
  },
  {
    p: "004305900500000007000002000050708200103600800806200003002009000000000010090000300",
    s: "214375986538946127967812534459738261123694875876251493342169758785423619691587342",
    d: -2767,
  },
  {
    p: "010005000000204009000060472060000007002050000007010930080001000490000500603000000",
    s: "214795368376284159958163472569438217132957846847612935785321694491876523623549781",
    d: -2767,
  },
  {
    p: "000050030000076000607020090090040000006000005108000300000300542040005080000960000",
    s: "214859736839476251657123498395641827426738915178592364961387542743215689582964173",
    d: -2767,
  },
  {
    p: "000040096000001003040050000008000200030000010100000000801500027002006040600810500",
    s: "215348796986721453743659182568193274437265918129487365891534627352976841674812539",
    d: -2767,
  },
  {
    p: "000000000000210003070805000040009700002100308001006004090070000400000000800640031",
    s: "215493687689217543374865129548329716762154398931786254193578462426931875857642931",
    d: -2767,
  },
  {
    p: "210000603407306500000100200100000004300900000000005307080040005004060080706080000",
    s: "215498673497326518863157249179632854358974126642815397981243765534761982726589431",
    d: -2555,
  },
  {
    p: "200800070000041850600002009020970000936100000080006000401060000070005000000010008",
    s: "215839476793641852648752319524973681936184725187526934451368297872495163369217548",
    d: -2468,
  },
  {
    p: "000009000378000000000008006000300090060800015923006040000270800050000000090004060",
    s: "216439587378615924549728136185347692467892315923156748634271859852963471791584263",
    d: -2767,
  },
  {
    p: "210090000009060300800205000080000147300000000000600090062300050000700001004050089",
    s: "216893475579461328843275916685932147391547862427618593162389754958724631734156289",
    d: -2961,
  },
  {
    p: "207503000400087001000000074000000800002390000000001000800900000045000090300600012",
    s: "217543986496287531538169274163475829782396145954821763821934657645712398379658412",
    d: -2767,
  },
  {
    p: "000300040000050000009001000060003108007600200850009004000080001004200600000700850",
    s: "218397546346852917579461382462573198197648235853129764735986421984215673621734859",
    d: -2767,
  },
  {
    p: "210090000000000081500080060000007035000009070907103000003200008400000500002708000",
    s: "218694753369572481574381269146827935835469172927153846793245618481936527652718394",
    d: -2862,
  },
  {
    p: "008006040090040020003000000400500000020061397301700054702039000050004000000000010",
    s: "218976543697345128543812976479523681825461397361798254782139465156284739934657812",
    d: -2555,
  },
  {
    p: "000085030000002009500000100600800405400060000003070000000120900024000000850009703",
    s: "219485637368712549547936182672893415495261378183574296736128954924357861851649723",
    d: -2862,
  },
  {
    p: "010000300000500000405100080000007009607040000140890000063000000800003956700008004",
    s: "219486375386572491475139682538627149697341528142895763963254817824713956751968234",
    d: -2468,
  },
  {
    p: "200004080060000000400090000600300500001970020000100073090700600300018009076000000",
    s: "219564387765831942483297165647382591831975426952146873598723614324618759176459238",
    d: -2862,
  },
  {
    p: "200000003000010050803700090500096100000850000007000200900400000076100400000000500",
    s: "219568743764913852853724691548296137132857964697341285985472316376185429421639578",
    d: -2677,
  },
  {
    p: "009580000060009405040000000701000068000030790800900000000000000000000537104207000",
    s: "219584673368719425547362819791425368456138792823976154675893241982641537134257986",
    d: -2767,
  },
  {
    p: "030040090900000050050932060000001000005724081180000007000400002004005010007260300",
    s: "231546798946187253758932164472891536365724981189653427593418672624375819817269345",
    d: -2745,
  },
  {
    p: "201000040000409380900530620500390000087002000000000050700000000000604000000080900",
    s: "231768549675429381948531627564397218387152496192846753723915864859674132416283975",
    d: -2767,
  },
  {
    p: "204000090517900400860002500006010300000807900021650000050000180600000000100030209",
    s: "234175698517968432869342571786419325345827916921653847452796183693281754178534269",
    d: -2848,
  },
  {
    p: "200100560005300024000000000003900070400008100800047000300090005002000843000050700",
    s: "234189567185376924796425381563912478427638159819547236378294615952761843641853792",
    d: -2468,
  },
  {
    p: "030050001090000080600091200040080090029004003000200100000010047000870000700003020",
    s: "234658971591327486678491235346185792129764853857239164982516347463872519715943628",
    d: -2468,
  },
  {
    p: "030780000050060300000102480600000000002003060903070010000520000500019000098300000",
    s: "234785196851964327769132485675491238412853769983276514346528971527619843198347652",
    d: -2961,
  },
  {
    p: "035008700010200008000001420098760040003000002006000000000009060007400013000080200",
    s: "235648791614297538789531426198762345573914682426853179352179864867425913941386257",
    d: -2468,
  },
  {
    p: "200100005059003080000008000300700040007042000500300700903000400840096200000000600",
    s: "238174965459623187176958324392715846617842539584369712963287451841596273725431698",
    d: -2468,
  },
  {
    p: "000900401000580000000000020002400079040700005780300000090000086003010504065004000",
    s: "238976451914582763576143928352461879649728315781359642497235186823617594165894237",
    d: -2468,
  },
  {
    p: "000000500005200000674108000003007050007004000900001003000000300000060892000489067",
    s: "238976514195243786674158239423897651517634928986521473869712345741365892352489167",
    d: -2961,
  },
  {
    p: "200100006105070300040900001000000030003004007070063908400020000000400090890600000",
    s: "239145786165872349748936251621798534983514627574263918417329865356487192892651473",
    d: -2468,
  },
  {
    p: "200501860514800300076004000190305706600000100000607200020060001060050423040000608",
    s: "239571864514826397876934512192385746687249135453617289728463951961758423345192678",
    d: -2772,
  },
  {
    p: "030800705054960002006020000301000070600073001000240000000002009000000007900400600",
    s: "239814765854967132716325498321689574648573921597241386165732849483196257972458613",
    d: -2468,
  },
  {
    p: "240700906000300040036004507010600728305000010800079000000040803000060000000520000",
    s: "241758936758396142936214587419635728375482619862179354527941863194863275683527491",
    d: -2745,
  },
  {
    p: "000760800090000100306000040960070000020190080050080007000300051000600002004200000",
    s: "241765839795834126386921745968573214427196583153482967872349651539618472614257398",
    d: -2862,
  },
  {
    p: "201003000000000070700008400100000000069500002000060030000900004400670010800200500",
    s: "241793685983456271756128493178342956369517842524869137635981724492675318817234569",
    d: -2677,
  },
  {
    p: "240000000080000300701500000300902005000000124000006007058000060009007000420800009",
    s: "243791856985624371761538492374912685896375124512486937158249763639157248427863519",
    d: -2862,
  },
  {
    p: "200000701000700020800104090000068200000005900030071068500000000006002400327000600",
    s: "243896751619753824875124396951368247768245913432971568594687132186532479327419685",
    d: -2555,
  },
  {
    p: "203900010000000007010000030080000060902000008700200400000501079005430002006070000",
    s: "243987516659314827817625934584793261932146758761258493428561379175439682396872145",
    d: -2862,
  },
  {
    p: "205000000089006040000400020060100400000020000000809005700043006000501000100000037",
    s: "245317869389256741671498523867135492593724618412869375728943156936571284154682937",
    d: -2767,
  },
  {
    p: "040300600903400000000000080000927000501063094300010000028000040000700300007000018",
    s: "245381679983476152716295483864927531571863294392514867628139745159748326437652918",
    d: -2468,
  },
  {
    p: "200580030000090000007306100300067050700004000000003920000000060034000500090000800",
    s: "246581739813792645957346182329167458785924316461853927578419263634278591192635874",
    d: -2767,
  },
  {
    p: "240009070000000000000002800900700050307504000004308000520460003009000607060000200",
    s: "246839571893175426175642839982716354317524968654398712528467193439251687761983245",
    d: -2468,
  },
  {
    p: "006001003080400000010000849008000031002083060400960020100000600007008050004710002",
    s: "246891573389457216715632849568274931972183465431965728123549687697328154854716392",
    d: -2745,
  },
  {
    p: "007050068105080000300000001090000870050070042002801000070000000010005400800000090",
    s: "247153968165982734389764521491526873658379142732841659573498216916235487824617395",
    d: -2862,
  },
  {
    p: "000070100930002040000000000003040020104600809095000004000000901000068000809503000",
    s: "248376195931852647567491238783149526124635879695287314356724981412968753879513462",
    d: -2862,
  },
  {
    p: "000010080108700004537080020020000019706040005004000700001004000000600900005030000",
    s: "249316587168752394537489126823567419716948235954123768671294853382675941495831672",
    d: -2468,
  },
  {
    p: "040507800800000450630800002004009000002700005091400670003008000000000200000172000",
    s: "249517836817236459635894712784659123362781945591423678123948567478365291956172384",
    d: -2555,
  },
  {
    p: "200000730000070408010030020000805600190000000030004209000020900000000007700008000",
    s: "249586731563271498817439526472895613195362874638714259386127945924653187751948362",
    d: -2677,
  },
  {
    p: "000470060030000000000600521109008000073060018802731600005090100004500730306000000",
    s: "251479863638125479497683521169258347573964218842731695725396184984512736316847952",
    d: -2958,
  },
  {
    p: "200000803908400200406500000360140000000760080000000050000000900500003007000000020",
    s: "251976843978431265436582179365148792129765384847329651614257938582693417793814526",
    d: -2677,
  },
  {
    p: "003600400009280000006000007000020800007100062080907501300000000670500000020030080",
    s: "253679418749281356816453297961325874537148962482967531394816725678592143125734689",
    d: -2961,
  },
  {
    p: "250900000060000032700003800090350160040000209006007000000005000000200000000038090",
    s: "253984617468571932719623845897352164345816279126497583984765321631249758572138496",
    d: -2767,
  },
  {
    p: "050000000103009000600034200017900054020700003000006000800000030009020800002000500",
    s: "254678391173259468698134275317982654926745183485316729841567932569423817732891546",
    d: -2767,
  },
  {
    p: "050093700700420950001508006400067000000084300007010040500800071800000090120759004",
    s: "254693718768421953391578426432967185915284367687315249549832671873146592126759834",
    d: -2661,
  },
  {
    p: "200000000780094003001020860005362001400000070008000000000700000000040007100009502",
    s: "254836719786194253391527864975362481412958376638471925529713648863245197147689532",
    d: -2862,
  },
  {
    p: "000043100070000085030009004000620000400085092300004000000708000025030007000100000",
    s: "256843179974261385138579264589627431417385692362914758641798523825436917793152846",
    d: -2862,
  },
  {
    p: "207980000008004500003001000000000080020010046009600701300005600000090020000348000",
    s: "257983164918264537463571892136457289725819346849632751394125678581796423672348915",
    d: -2468,
  },
  {
    p: "007000010400000500003045609000000150029100030060538090005007040810060000000000000",
    s: "257986413496713582183245679348692157529174836761538294635827941814369725972451368",
    d: -2468,
  },
  {
    p: "058000603060009027070200040004008036020016004096030000040002008002680050100005000",
    s: "258147693463859127971263845514728936327916584896534271645392718732681459189475362",
    d: -2958,
  },
  {
    p: "058100700000040006000002905020000508600008020030900040006035070000070000080001060",
    s: "258169734179543286463782915724316598691458327835927641946835172312674859587291463",
    d: -2468,
  },
  {
    p: "000410000600000000073005410004070120009800005005001604006030800000004070000090050",
    s: "258419367641387592973265418864573129129846735735921684596732841382154976417698253",
    d: -2961,
  },
  {
    p: "008600000060320000040000005000800090400010080800006010012004007076000003000050020",
    s: "258647139169325478743198265631872594427519386895436712312964857576281943984753621",
    d: -2767,
  },
  {
    p: "000704001367000005000002806001030020030001009095000400000000000409005008000120000",
    s: "258764391367819245914352876841936527732541689695287413186493752429675138573128964",
    d: -2862,
  },
  {
    p: "000000360109500004070800200605000720000000000010700000001006000300090040562001000",
    s: "258947361139562874476813295695134728723658419814729653941376582387295146562481937",
    d: -2767,
  },
  {
    p: "000000840083000200004052090500000080000500010000406502001007004700000000305020960",
    s: "259763841683914275174852693567231489432589716918476532821697354796345128345128967",
    d: -2961,
  },
  {
    p: "203000040040000029001264700800100000000570000300020490090007030600010905004000086",
    s: "263795841547381629981264753879143562426579318315826497198657234632418975754932186",
    d: -2745,
  },
  {
    p: "004009735009000040050002000000780000080050420107900600003000080040003100000000006",
    s: "264819735879635241351472869425786913986351427137924658613297584748563192592148376",
    d: -2862,
  },
  {
    p: "000000300800000900003274500706005010050000002400300608600040200500136000309000000",
    s: "265918347874653921193274586736825419958461732412397658681549273527136894349782165",
    d: -2555,
  },
  {
    p: "068000045007210000000080090100004006009030002030060008000000000025109600000000309",
    s: "268397145947215863513486297182754936659831472734962518896543721325179684471628359",
    d: -2862,
  },
  {
    p: "060000000150003467000061085000007000604050078005204030003500009040090000972100000",
    s: "268475391159823467437961285391687542624359178785214936813546729546792813972138654",
    d: -2848,
  },
  {
    p: "000003000003069002000200003459800000082035600000000000007000940010000200605004307",
    s: "268543179743169852591278463459826731182735694376491528837612945914357286625984317",
    d: -2468,
  },
  {
    p: "073190008060205000010007000002004010001080703300000546000000007000020390030900000",
    s: "273196458864235971519847632752364819641589723398712546926453187487621395135978264",
    d: -2555,
  },
  {
    p: "003050096600800000084070050001030060506004201002000400000283600000000000008000300",
    s: "273451896615829743984376152841532967536794281792618435457283619369147528128965374",
    d: -2961,
  },
  {
    p: "000050006001800000308070010000600000007000900102009670000130000700002485000000002",
    s: "274351896651894327398276514539617248867423951142589673425138769713962485986745132",
    d: -2767,
  },
  {
    p: "000408001308090000090000000080070004740601050000000100800000005032900070007100306",
    s: "275438961318596742694217583581379624743621859926854137869743215132965478457182396",
    d: -2468,
  },
  {
    p: "000300008800500061100007400900001000000023000700400300007000086000179000509006030",
    s: "276314598834592761195687423983751642641923875752468319417235986368179254529846137",
    d: -2468,
  },
  {
    p: "200300019000000000548000027060709000354006702000000000000803000000007803100090004",
    s: "276358419931472586548961327862739145354186792719524638627843951495217863183695274",
    d: -2468,
  },
  {
    p: "206090041903005006005700000600002000080001900700000200000509004300800000000010700",
    s: "276398541943125876815764392631982457582471963794653218127539684369847125458216739",
    d: -2862,
  },
  {
    p: "200500010400820007000000300001900200007000000830001056002700090040060000060400708",
    s: "278536419413829567596147382651984273927653841834271956382715694749368125165492738",
    d: -2468,
  },
  {
    p: "079010050650000003100470600000081000810004000043050090000130000000000584080000000",
    s: "279613458654829713138475629596381247812794365743256891465138972321967584987542136",
    d: -2468,
  },
  {
    p: "201050300400030180300008000020089000500300000000027890000000000010704020000090005",
    s: "281456379457932186369178452724689531598341267136527894973215648815764923642893715",
    d: -2862,
  },
  {
    p: "000050760043001000000030004700006400015074030000800002138900000000000000002000008",
    s: "281459763643721859957638214729316485815274936364895172138962547496587321572143698",
    d: -2767,
  },
  {
    p: "200009000000000001060001300054703908073000000010500007040092086008100240700004000",
    s: "281639574439275861567481329654723918873916452912548637145392786398167245726854193",
    d: -2648,
  },
  {
    p: "201050000040000500905800724070160430000000007036400000402300600690008000050001042",
    s: "281754396743926581965813724879162435124539867536487219412395678697248153358671942",
    d: -2958,
  },
  {
    p: "200000000073000000590080710060000050900030400300071200020000000000645000106098500",
    s: "281967345673154982594382716467829153912536478358471269825713694739645821146298537",
    d: -2468,
  },
  {
    p: "000060010005000000076852900000700000830905000040000892000000000300207000000138706",
    s: "283469517495371268176852943629784135831925674547613892712546389368297451954138726",
    d: -2468,
  },
  {
    p: "004100706000000002961400000607090000403058007000002050000080200000000000049000005",
    s: "284135796375869142961427538657391824423658917198742653536984271812573469749216385",
    d: -2767,
  },
  {
    p: "000090015000100840050380207000530000000602431012009500028003004037000002400050083",
    s: "284796315673125849951384267746531928895672431312849576128963754537418692469257183",
    d: -2557,
  },
  {
    p: "000100003000200040954000000000709600507040000020608000402000000000000900108020070",
    s: "286174593713295846954863217841759632567342189329618754492587361675431928138926475",
    d: -2677,
  },
  {
    p: "006100090037000020000230058023764000098000000400003000000380407000007005800000000",
    s: "286175394537948126941236758123764589798512643465893271652389417319427865874651932",
    d: -2961,
  },
  {
    p: "200000010300000000000003820029040005000008760074000000000000900093002087008701000",
    s: "287569413316284579945173826829647135531928764674315298752836941193452687468791352",
    d: -2767,
  },
  {
    p: "000300560800005700000419000000000025000090006700000901042070030050100000310020000",
    s: "291387564834265719576419283169743825425891376783652941942576138657138492318924657",
    d: -2862,
  },
  {
    p: "000008000003000729000002001010005080800090007060010030900347000000080000420006000",
    s: "291578643583461729674932851319725486845693217762814935958347162136289574427156398",
    d: -2767,
  },
  {
    p: "200005000407090002000000069000106050005000673900300008002000000830400010050000306",
    s: "293645781467891532581723469328176954145982673976354128612539847839467215754218396",
    d: -2961,
  },
  {
    p: "090006000000000034076001020325400900000000080810900000002008400000509000700200065",
    s: "293846157158792634476351829325487916964125783817963542532678491641539278789214365",
    d: -2468,
  },
  {
    p: "000700500000045000008060400412009007000000006930008000320006900009050002050201040",
    s: "294713568163845729578962431412639857785124396936578214321486975649357182857291643",
    d: -2555,
  },
  {
    p: "000080300460700050010000020030600075002030090851000000000071000000000932000000080",
    s: "295486317463712859718359624934628175672135498851947263329871546187564932546293781",
    d: -2767,
  },
  {
    p: "205700048000000009764000230000900000000002900000007064170604300080053000000000001",
    s: "295736148831425679764891235617948523548362917923517864179684352482153796356279481",
    d: -2468,
  },
  {
    p: "090400080006708200051000060000000000003005000005020010932000100000600090000001738",
    s: "297456381346718259851932467129364875683175924475829613932587146718643592564291738",
    d: -2862,
  },
  {
    p: "007001000000032009006500000870003024005100800600040000000000008700250000523900060",
    s: "297461385458732619316589742871693524945127836632845971169374258784256193523918467",
    d: -2468,
  },
  {
    p: "000601408000700605006930100870304000004000007600000300000007050000820006020009000",
    s: "297651438183742695456938172872394561534186927619275384368417259945823716721569843",
    d: -2468,
  },
  {
    p: "097000400040605200600002900000000090370020054009018000000000007005000002100400000",
    s: "297831465843695271651742938512374896378926154469518723984263517735189642126457389",
    d: -2767,
  },
  {
    p: "200050001530000900040000253000102830380000109000060500700000000104028305003400072",
    s: "298354761531276984647981253475192836386547129912863547729635418164728395853419672",
    d: -2958,
  },
  {
    p: "000060070000000406040910000900030004030020010560198300700000609000800100350000000",
    s: "298364571173582496645917238912735864837426915564198327781253649426879153359641782",
    d: -2468,
  },
  {
    p: "008507004000010803000000000009003640320008500007060002000000016000080200100695700",
    s: "298537164574916823631824975819253647326748591457169382985372416763481259142695738",
    d: -2555,
  },
  {
    p: "010000000090320050700000103080630000200000090451009070004073900000006000609000400",
    s: "312547689896321754745968123987635241263714895451289376524173968178496532639852417",
    d: -2468,
  },
  {
    p: "010200970005004000000300200470028000000905304800000000006003000700000068000000000",
    s: "314286975925714836687359241473628159162975384859431627596843712731592468248167593",
    d: -2591,
  },
  {
    p: "010800570096020040000700000040000000902008000008210003001036008600000050050000637",
    s: "314869572796325841825741369147693285932458716568217493471536928683972154259184637",
    d: -2555,
  },
  {
    p: "000000762000007100042003000071958200020000490000000000003180000050300900100002050",
    s: "315849762986527143742613589471958236628731495539264817293185674854376921167492358",
    d: -2961,
  },
  {
    p: "306000020008100000900020107050900700760082540000050000000000090030076002000001000",
    s: "316745928278169453945823167852914736761382549493657281127538694539476812684291375",
    d: -2862,
  },
  {
    p: "007090060802013004500000001600001052005000480040200030000900000200607000008005000",
    s: "317594268862713594594826371683471952125369487749258136436982715251637849978145623",
    d: -2468,
  },
  {
    p: "000000405950000000086043000690800070001900040002000806005000008100000030020300907",
    s: "317689425954271683286543719693824571871965342542137896735492168169758234428316957",
    d: -2961,
  },
  {
    p: "000007009000060000900013520802400050070500030000009800000000008000000370047005600",
    s: "318257469725964183964813527892431756176528934453679812531796248689142375247385691",
    d: -2767,
  },
  {
    p: "309000204200100058600900010000890000073005000100006000000000003000000006005308000",
    s: "319587264247163958658942317526894731873215649194736825982651473731429586465378192",
    d: -2677,
  },
  {
    p: "000100907000003080800920030100006200002000003530000690000200001206800000003000509",
    s: "324168957961753482875924136198376245642589713537412698459237861216895374783641529",
    d: -2468,
  },
  {
    p: "300000900000000127700080000000000200065401000802000000090102050000070806006003000",
    s: "324716985689345127751289634137658249965421378842937561498162753213574896576893412",
    d: -2677,
  },
  {
    p: "305100060900600400004700002480006300100080700000310000000000040048067020609430005",
    s: "325148967971625438864793512482576391193284756756319284237851649548967123619432875",
    d: -2848,
  },
  {
    p: "306700451000201006700000002290140005801000000435000109670000000043000900500003060",
    s: "326789451954231876718456392297148635861395247435672189679824513143567928582913764",
    d: -2958,
  },
  {
    p: "307000800100000040065007000096300007000010200040070560000600000050109000003000000",
    s: "327461859189253746465897312596342187738516294241978563874625931652139478913784625",
    d: -2677,
  },
  {
    p: "027006100900400506004090780500000600810349000000050000002008000000000000030000097",
    s: "327586149981473526654192783579821634816349275243657918762938451498715362135264897",
    d: -2862,
  },
  {
    p: "307001000000000870005000000200040000600080210000370000053000120910000400760009050",
    s: "327891546196534872845627931239146785674985213581372694453768129918253467762419358",
    d: -2862,
  },
  {
    p: "000000600005003000710000005104602900030400120060030000200900010000005000450201030",
    s: "328514697645793281719826345184652973537489126962137458273968514891345762456271839",
    d: -2468,
  },
  {
    p: "000500049000920380000080000034100060060000020007050000000000194900002000500400007",
    s: "328571649756924381419683572234198765165347928897256413672835194943712856581469237",
    d: -2767,
  },
  {
    p: "300050006084061000000703400061300008007280000000070200008000104002500000910000050",
    s: "329458716784961325156723489261394578437285961895176243578632194642519837913847652",
    d: -2555,
  },
  {
    p: "300070680780004000602030007209050003010400006400000102000107008800000001107805020",
    s: "341279685785614239692538417269751843513482796478396152954127368826943571137865924",
    d: -2958,
  },
  {
    p: "040956000900302154005014000100009605080070300200000400009000860010590043000607501",
    s: "341956278967382154825714936174239685586471329293865417759143862612598743438627591",
    d: -2661,
  },
  {
    p: "001000205008710400000400900400080600050006000070103008500000000000009030002300000",
    s: "341968275928715463765432981413587629859246317276193548537824196184659732692371854",
    d: -2677,
  },
  {
    p: "002100700180073000900208030206004000053060018070000000090000105000007200000009000",
    s: "342195786185673492967248531216984357453762918879531624798326145534817269621459873",
    d: -2468,
  },
  {
    p: "000087000705041300890530000400700800200000097000003005600008003030000970004006002",
    s: "342687519765941328891532764456729831283415697917863245629178453138254976574396182",
    d: -2648,
  },
  {
    p: "000000000195002040000030000600250000029070060030060097000690073870000000000100054",
    s: "342916785195782346786534912617259438429873561538461297254698173871345629963127854",
    d: -2961,
  },
  {
    p: "005060090000002000000700541000010403400000100700080600000003007596004000270008000",
    s: "345861792917542836628739541852916473469327185731485629184693257596274318273158964",
    d: -2862,
  },
  {
    p: "000007008000060400729000500000480367000000040090000200004700030050200080001800000",
    s: "346157928185962473729348516512489367637521849498673251864795132953216784271834695",
    d: -2767,
  },
  {
    p: "007102900010900000000084307008000005460001000950000003002049000680700000700003000",
    s: "347152968816937524529684317278396145463571892951428673132849756684715239795263481",
    d: -2961,
  },
  {
    p: "340000010107000800500009006400000500091703000000004900000012000000090058002500064",
    s: "349268715167345829528179436476921583891753642235684971654812397713496258982537164",
    d: -2961,
  },
  {
    p: "000080020106200090070030000000100000000070030432000060500640000090300100600008000",
    s: "349781625186254397275936814758163942961472538432895761517649283894327156623518479",
    d: -2677,
  },
  {
    p: "001600000009047000000900256000034090503000700700005800008302905604000000030000000",
    s: "351628479269547381487913256816734592593286714742195863178362945624859137935471628",
    d: -2468,
  },
  {
    p: "050800000006005000000020700010200000203007040460000300000000603780600105000100002",
    s: "352876914976415238148329756817243569293567841465981327521794683784632195639158472",
    d: -2767,
  },
  {
    p: "054006800000085000200070064760000030902500700801020000003000478010000950080750000",
    s: "354296817176485392298371564765148239942563781831927645523619478417832956689754123",
    d: -2848,
  },
  {
    p: "000010000096080005800073000000000708040038900000900061003006000000290070000000400",
    s: "354619287796482135812573694239165748641738952587924361173846529465291873928357416",
    d: -2677,
  },
  {
    p: "000800400800560000012390008297000630008040905005000007004030000960080000020000000",
    s: "356812479879564312412397568297158634138746925645923187784639251961285743523471896",
    d: -2555,
  },
  {
    p: "007004029060000400180060050000009003000710000030200908010000500090007010000400000",
    s: "357184629269375481184962357672859143948713265531246978713628594496537812825491736",
    d: -2767,
  },
  {
    p: "000200100904000807000300900070006000230009001000150004093001002060040000000000000",
    s: "358297146924615837716384925471826593235479681689153274893761452567942318142538769",
    d: -2677,
  },
  {
    p: "000200070000060000860009040030500000007023805040000000704900308003000104900080007",
    s: "359248671472165983861739542138597426697423815245816739724951368583672194916384257",
    d: -2468,
  },
  {
    p: "300200070061008020008400000000700350030010290902036000003000008507009610100000900",
    s: "359261874461978523278453169846792351735814296912536487693125748587349612124687935",
    d: -2745,
  },
  {
    p: "300000020200080006060902731830004070000000040001090650625300000100040000070000000",
    s: "359671824217483596468952731832564179596137248741298653625319487183745962974826315",
    d: -2555,
  },
  {
    p: "302000001000096000000402006000009020000027080000500000130000400750013600090000700",
    s: "362785941487196235915432876573869124641327589829541367136978452754213698298654713",
    d: -2767,
  },
  {
    p: "060028000000005801080900023003000007100702004000000000950000060000600075000400010",
    s: "364128759279365841581974623823546197196732584745891236957213468412689375638457912",
    d: -2767,
  },
  {
    p: "364095070000000000102006000000000000537001900209850010403007009070340158000000003",
    s: "364295871795418326182736495618974532537621984249853617453187269976342158821569743",
    d: -2848,
  },
  {
    p: "360005080080001057005080460601020700050000000009107030003000048040008010016000903",
    s: "364975281982461357175283469631824795758639124429157836293716548547398612816542973",
    d: -2958,
  },
  {
    p: "005071000000003007800062400000238090018740206003000004030080742000027069702600305",
    s: "365471928429853617871962453647238591918745236253196874136589742584327169792614385",
    d: -2772,
  },
  {
    p: "005790000800005000071030008400000930630200070907000000000000407009000000000004810",
    s: "365798241894125763271436598412687935638259174957341682586913427149872356723564819",
    d: -2767,
  },
  {
    p: "300900000081000000400000050002700006000420000600500800000100094010207030000834570",
    s: "365941782781352469429678153152783946978426315643519827837165294514297638296834571",
    d: -2961,
  },
  {
    p: "000010089500000010090030740003026004900000000804000000000672800730000000000040201",
    s: "367214589548769312291538746173826954926457138854193627415672893732981465689345271",
    d: -2862,
  },
  {
    p: "000100007010098000900006500006805002801200000240007600480000050020000000009500860",
    s: "368154927512798346974326518796845132851263479243917685487639251625481793139572864",
    d: -2555,
  },
  {
    p: "308000000700026500500003610000075040003000000090030008050004000810000060000001900",
    s: "368517492741926583529843617286175349173498256495632178957264831812359764634781925",
    d: -2767,
  },
  {
    p: "060005180000080000004302000402006710130900000070010630000090500000040020050000000",
    s: "369475182725189463814362957492836715136957248578214639243698571987541326651723894",
    d: -2862,
  },
  {
    p: "009000018050000700002610009004006000800020000075004000030090607080060200000200053",
    s: "369752418158349726742618539924186375813527964675934182231895647587463291496271853",
    d: -2468,
  },
  {
    p: "070000900000049001010007046200030157000002000050490020000500000036070010400600003",
    s: "374165982568249371912387546249836157681752439753491628197523864836974215425618793",
    d: -2555,
  },
  {
    p: "375190480020004070000005030700900050010200000860000000000609840000701503207400010",
    s: "375192486928364175641875932734916258519238764862547391153629847496781523287453619",
    d: -2958,
  },
  {
    p: "070000100000030000090056830000945008001000067003007000000000089654003000000000500",
    s: "375489126468231795192756834726945318541328967983167452237514689654893271819672543",
    d: -2767,
  },
  {
    p: "005000080000053000010000630080291000000000006041300092000780020730006100800002000",
    s: "375619284426853971918427635687291543293574816541368792164785329732946158859132467",
    d: -2961,
  },
  {
    p: "005010000040006009980003050200000000638009000000130502000720900000000700014000000",
    s: "375912486142586379986473251251647893638259147497138562863724915529861734714395628",
    d: -2767,
  },
  {
    p: "300020906001009500400630000600000007000000800905340000003070000000900100097000608",
    s: "378524916261789534459631782614298357732165849985347261123876495846952173597413628",
    d: -2862,
  },
  {
    p: "070000406000006000000043059008100000600009738000300004253070000090004270000500000",
    s: "379851426584296317162743859438167592615429738927385164253978641891634275746512983",
    d: -2468,
  },
  {
    p: "301560900064000012000000800000050400020090000000084005000600290009000004800049500",
    s: "381562947564978312297431856178256439425397681936184725743615298659823174812749563",
    d: -2468,
  },
  {
    p: "000000000060010700207006010042100030000009004610007008000300006020078000073900200",
    s: "381794562564213789297856413942185637738629154615437928159342876426578391873961245",
    d: -2468,
  },
  {
    p: "000004506090001000000638000130090070002003104006000300020500090010800005009000001",
    s: "381974526697251438245638917138495672952763184476182359824516793713849265569327841",
    d: -2468,
  },
  {
    p: "304907010709008300060000000000040160100000503000280000903460000000003702000000000",
    s: "384957216719628345562134987297345168148796523635281479973462851456813792821579634",
    d: -2862,
  },
  {
    p: "000070010009000024004310080008700000500908700003005800000040000030800462010007000",
    s: "386472915179586324254319687698734251521968743743125896865243179937851462412697538",
    d: -2468,
  },
  {
    p: "300406050005093000427108000000600300200080700000040005090700006102800570000032840",
    s: "389476152615293487427158963541627398263589714978341625894715236132864579756932841",
    d: -2958,
  },
  {
    p: "301070028700082000000000051409210000000000060002065030000001000650000907000000300",
    s: "391576428745182693286934751469213875513897264872465139937641582654328917128759346",
    d: -2862,
  },
  {
    p: "300005000067020030482000000000301020000090086600802050100000900820900503003706002",
    s: "391685247567429138482173695758361429214597386639842751175238964826914573943756812",
    d: -2848,
  },
  {
    p: "000004060070000380560370190600000000107900002000000940000048000000000430900160000",
    s: "391854267472619385568372194689425713147936852235781946713548629856297431924163578",
    d: -2862,
  },
  {
    p: "000000000605003002180209306000406050800000200000100809000000700704310000903005000",
    s: "392641587645873912187259346279486153831597264456132879568924731724318695913765428",
    d: -2468,
  },
  {
    p: "000210060000093002800400900034980100107060409000000000000529070500000000280104305",
    s: "395218764741693852862457913634985127157362489928741536413529678579836241286174395",
    d: -2848,
  },
  {
    p: "305002740000080105000900003080000009000050200500000310009703000000049000070100000",
    s: "395612748762384195148975623684231579931457286527896314859723461216549837473168952",
    d: -2767,
  },
  {
    p: "095700000010600000002080137800000009040003000000910000587000000000000806006004703",
    s: "395741268718632945462589137871465329649273581253918674587396412934127856126854793",
    d: -2862,
  },
  {
    p: "090050700800000400401760853900006302008900000000001000000500080000012007600000010",
    s: "396458721857123469421769853915876342248935176763241598132597684584612937679384215",
    d: -2468,
  },
  {
    p: "007000500000920010280003000004800730000070005900015860700006002000500000460200050",
    s: "397461528546928317281753649654892731813674295972315864735146982128539476469287153",
    d: -2555,
  },
  {
    p: "307500000000000002821000060000700301000015000500902400240000500600390080000000000",
    s: "397526148456189732821473965962748351734615829518932476249867513675391284183254697",
    d: -2767,
  },
  {
    p: "000402000005030200000000530700210800000740000609000007057000003240000005800900060",
    s: "398452671175638249462197538734219856581746392629583417957864123246371985813925764",
    d: -2862,
  },
  {
    p: "000000000054070200070300015009050783000030009000904000840020000010000070620003100",
    s: "398512647154679238276348915469251783581736429732984561845127396913465872627893154",
    d: -2961,
  },
  {
    p: "002000006076001000900040000300050000840200500000096470005700000000800045000000200",
    s: "412573896576981324938642751367458912849217563251396478185724639723869145694135287",
    d: -2677,
  },
  {
    p: "400600000090084100000097320000200709206000000000000050100030800607002000800009070",
    s: "413625987792384165568197324345268719276951438981473256159736842637842591824519673",
    d: -2862,
  },
  {
    p: "010000025089000000500900063000030206300702408700005300007000000001000040250080000",
    s: "413678925689523714572941863145839276396712458728465391967354182831296547254187639",
    d: -2468,
  },
  {
    p: "005000609638050000900310000100000200250000006003004000000700400870020010000000300",
    s: "415872639638459127927316854146597283259138746783264591391785462874623915562941378",
    d: -2767,
  },
  {
    p: "010500000000003000000000049040000800002090030708054000300470105120000380805310490",
    s: "416589273297643518583127649941736852652891734738254961369478125124965387875312496",
    d: -2745,
  },
  {
    p: "010092030560300001008100540741000000800009000000700000030000806600004300000200005",
    s: "417592638562348791398176542741625983826439157953781264234957816675814329189263475",
    d: -2468,
  },
  {
    p: "000860023060000840208419670001086002005040000680000100870050309000000000396070050",
    s: "417865923569732841238419675741986532925143786683527194872654319154398267396271458",
    d: -2557,
  },
  {
    p: "410000090500009700700000020000050800840000000090320000006037500100400600930005000",
    s: "418276395523819764769543128372954816845761932691328457286137549157492683934685271",
    d: -2862,
  },
  {
    p: "000000003000002865600807001000980200900000570801600030700064000004020000003100000",
    s: "418596723379412865652837491547983216936241578821675934795364182164728359283159647",
    d: -2468,
  },
  {
    p: "409600000030005100005004000340007000080000010700290860000000000000800752000009003",
    s: "419638275837925146265714938346187529982456317751293864578362491693841752124579683",
    d: -2767,
  },
  {
    p: "400500009000020000000730500070000900000080170604307000350400016800062000006800000",
    s: "423516789785924631961738542578241963239685174614397258352479816847162395196853427",
    d: -2468,
  },
  {
    p: "420000800030007640000630010100072080860040500005010300000000000090000400000009100",
    s: "426195837531287649789634215143572986862943571975816324614358792298761453357429168",
    d: -2862,
  },
  {
    p: "006000300907060000000240100000000602000807000032090400651000809200000000000003010",
    s: "426715398917368524385249167579134682164827953832596471651472839293681745748953216",
    d: -2767,
  },
  {
    p: "027001300010005004500800000006908200000000700704000050003000000000100020000000018",
    s: "427691385618325974539847162356978241281456739794213856143582697875169423962734518",
    d: -2591,
  },
  {
    p: "027000006890206700000000048030720094001900070000310020902000000000100000600090000",
    s: "427831956895246731163579248536728194241965873789314625912653487374182569658497312",
    d: -2961,
  },
  {
    p: "000081030010502009009300400350060800200000670004030000000000200800100000002700000",
    s: "427981536613542789589376412351267894298415673764839125175693248836124957942758361",
    d: -2767,
  },
  {
    p: "408100003000000000000607005302000108000800907040060300000000000065090704010072000",
    s: "428159673576234891139687425392745168651823947847961352784516239265398714913472586",
    d: -2862,
  },
  {
    p: "008653007000740030000800000670500000090000061000400080040000000003005420157000000",
    s: "428653917561749238739812654672581349894327561315496782246938175983175426157264893",
    d: -2862,
  },
  {
    p: "028010703006040000000008000280500104000800200640002000907000501100309020002071000",
    s: "428915763516743982379628415283567194791834256645192378937286541164359827852471639",
    d: -2745,
  },
  {
    p: "020500000008460000000008314100809700060001503800670200000000050004000030001000008",
    s: "429513867318467925675928314152839746967241583843675291736182459584796132291354678",
    d: -2961,
  },
  {
    p: "400000005005298000830400620060000200010379004000000510000005040000702000000160000",
    s: "429613785675298431831457629368541297512379864947826513786935142194782356253164978",
    d: -2961,
  },
  {
    p: "400000000000209005563080400302567000000900000010008003147006200000000100000000900",
    s: "429635781871249365563781429392567814684913572715428693147396258936852147258174936",
    d: -2862,
  },
  {
    p: "000200900000000824800600000000008007309000200000003009070000501054090000210040300",
    s: "431287965765139824892654173526918437349576218187423659973862541654391782218745396",
    d: -2767,
  },
  {
    p: "000000500200600100000042008003704802020000900090081000600000004307010000100530000",
    s: "431978526278653149965142738513794862824365971796281453659827314387416295142539687",
    d: -2862,
  },
  {
    p: "000000000081070006750482000200000000304250000000000017000800002003600000005320090",
    s: "432196875981573426756482931219768543374251689568934217197845362823619754645327198",
    d: -2767,
  },
  {
    p: "030000607000800005000650390200080001090421500501000000003245869902008053850963000",
    s: "435192687679834125128657394247586931396421578581379246713245869962718453854963712",
    d: -2890,
  },
  {
    p: "030100000897004200502000004000007059020500400000000007009800502070000100600300700",
    s: "436128975897654231512793684164237859723589416985416327349871562278965143651342798",
    d: -2468,
  },
  {
    p: "030700900800095700000000814000080000504000020200070086650000000000209030002000009",
    s: "436718952821495763975623814167382495584961327293574186659137248748259631312846579",
    d: -2862,
  },
  {
    p: "437080000800100900100002000000000143000000006000020000001970005076500320004000080",
    s: "437689512862157934195432678528796143743815296619324857281973465976548321354261789",
    d: -2862,
  },
  {
    p: "008010002070002500950700006000000490000059031000230000740500000500807600200300000",
    s: "438615972671982543952743816325176498867459231194238765746521389513897624289364157",
    d: -2555,
  },
  {
    p: "409100087050000004702094000000089060000010400210046050060070100008002000000000600",
    s: "439165287651827934782394516574289361896513472213746859965478123148632795327951648",
    d: -2555,
  },
  {
    p: "030100702261000003000000004004008001520000800000009000090070600012004500000090000",
    s: "439186752261745983857932164974658321523417896186329475395271648712864539648593217",
    d: -2767,
  },
  {
    p: "039000052006100007080004000000000000250060304190020600000000700040095000000000230",
    s: "439678152526139487781254963863947521257861394194523678615382749342795816978416235",
    d: -2767,
  },
  {
    p: "001062090080410600070000300000070000000800004000103000540000003006000008109020006",
    s: "451362897983417625672985341314276589267859134895143762548691273726534918139728456",
    d: -2767,
  },
  {
    p: "000100076000000000008200005045000002000302000000006409514900608600050100800003090",
    s: "452139876169785243378264915745891362986342751231576489514927638693458127827613594",
    d: -2468,
  },
  {
    p: "400030001900480000080000706000000500003002600700000008010500090005070300000006002",
    s: "452637981976481235381259746168794523543812679729365418614523897295178364837946152",
    d: -2677,
  },
  {
    p: "050180070000074500000500009694000000078003420000000007000900004082000000106000080",
    s: "453189276869274513217536849694712358578693421321845697735928164982461735146357982",
    d: -2862,
  },
  {
    p: "000000019200010000800600700000000000008204000000001594670020000509060030021490060",
    s: "456782319297513648813649725145976283938254176762831594674328951589167432321495867",
    d: -2468,
  },
  {
    p: "000900803030400012080076000008000020710005060095010300000700900160000000000000000",
    s: "456921873937458612281376594348697125712835469695214387824763951169542738573189246",
    d: -2767,
  },
  {
    p: "450000070003609054000000000725006000009070830006000000000001000000000367800500900",
    s: "458312679273689154691457283725836491149275836386194725932761548514928367867543912",
    d: -2767,
  },
  {
    p: "400000700200090000083210000000109000007000000590072160000000090075804003034006000",
    s: "459683721261497358783215946342169587617548239598372164826731495975824613134956872",
    d: -2961,
  },
  {
    p: "009080260200000000600950073108075000003010005004000900010004020000300000005000030",
    s: "459783261237146859681952473198675342723419685564238917316594728872361594945827136",
    d: -2862,
  },
  {
    p: "400000000003000002050963004890035000300610000020008703000109200570206000000000800",
    s: "461827935983541672752963184896735421347612598125498763638159247574286319219374856",
    d: -2555,
  },
  {
    p: "000028000900670200370000009004100025090800000200500000000000030010000487540001000",
    s: "461928753958673214372415869784136925195842376236597148829764531613259487547381692",
    d: -2862,
  },
  {
    p: "000000079018002004200900080021005600800076300000000000600100708000000056095000000",
    s: "463581279918732564257964183321895647849276315576413892634159728182347956795628431",
    d: -2862,
  },
  {
    p: "000000209700068010001000065009650000000082000004007300000000500206140070507000040",
    s: "465371289792568413381294765179653824653482197824917356948726531236145978517839642",
    d: -2468,
  },
  {
    p: "460002080003000097000160000050000308089004210206000000000080000000005004540700900",
    s: "467392581123548697895167432754219368389674215216853749972486153631925874548731926",
    d: -2468,
  },
  {
    p: "400000009000310000103064000080030097000500006300076010017020903000700260600940700",
    s: "468257139275319684193864572586132497741598326329476815817625943954783261632941758",
    d: -2848,
  },
  {
    p: "400350090000008024905100006856000201070010000040700300000900000000000000100047050",
    s: "468352197713698524925174836856439271379216485241785369584963712637521948192847653",
    d: -2961,
  },
  {
    p: "060003007950000038700200000005006000034500200800007010680009000000060004000000800",
    s: "468913527952674138713285649275146983134598276896327415681439752527861394349752861",
    d: -2767,
  },
  {
    p: "469000070500100002100800600007053100008000400000709500705030000000000000000010006",
    s: "469325871583176942172894635927453168358261497641789523795638214216547389834912756",
    d: -2767,
  },
  {
    p: "000063008090050001080000003030400100000096000007000080010032060600005970000007000",
    s: "471263598396854721285719643932478156148596237567321489714932865623185974859647312",
    d: -2767,
  },
  {
    p: "401302009005490000060017000000000973130500420000639000000060007600700810200000300",
    s: "471352689825496731963817542586241973139578426742639158358164297694723815217985364",
    d: -2848,
  },
  {
    p: "000030009008000000500008706920007010040000600000419000060280004010900050000500007",
    s: "471632589698754321532198746923867415147325698856419273765281934314976852289543167",
    d: -2862,
  },
  {
    p: "000000931009003408000410020060000749194000000020008000000320500000000800300507092",
    s: "472865931619273458538419627863152749194736285725948316987321564251694873346587192",
    d: -2648,
  },
  {
    p: "000000080810020403603070002000000004005040008007805310000250000026091000100000000",
    s: "472913586819526473653478192981732654365149728247865319738254961526391847194687235",
    d: -2961,
  },
  {
    p: "070018000100000000509070018006080072200095006701600090842000609615000040000060021",
    s: "473218965128956734569473218956381472234795186781642593842137659615829347397564821",
    d: -2557,
  },
  {
    p: "073600002500000000000013840040000000600480030100060200020000079906074100700005068",
    s: "473698512581742693269513847347251986652489731198367254825136479936874125714925368",
    d: -2745,
  },
  {
    p: "006003000008200007100040000030001500600400000040005970010080300203506000000007005",
    s: "476153298358269417129748653732891564695472831841635972517984326283516749964327185",
    d: -2862,
  },
  {
    p: "000001008008600702290000006000000305600200100020573080301007000004010000080400000",
    s: "476321958518694732293785416847169325635248197129573684361857249754912863982436571",
    d: -2961,
  },
  {
    p: "470120300059000800000000009030000900740000000080040120100900200020007500000850000",
    s: "478129356659473812213586749532761984741298635986345127165934278824617593397852461",
    d: -2862,
  },
  {
    p: "008200000000053010000670249002760400090040050604000090107000000060900000500100000",
    s: "478291563926453817315678249852769431791342658634815792187536924263984175549127386",
    d: -2961,
  },
  {
    p: "470020005000000900000001702000402087040100029302000001004906000731040090906870210",
    s: "478329165215764938693581742169452387547138629382697451824916573731245896956873214",
    d: -2557,
  },
  {
    p: "070002000003000000002000650091200540030140090700006002040000800050007100000090070",
    s: "478562931563719284912384657691273548235148796784956312147635829859427163326891475",
    d: -2862,
  },
  {
    p: "001000000005870004000000000004100070000040030960000000017003042200960007000004108",
    s: "481396725395872614726415893854139276172648539963257481617583942248961357539724168",
    d: -2767,
  },
  {
    p: "001003000000000805200894100008200400010000050042500701000000200907000004000706003",
    s: "481653927396127845275894136538271469719468352642539781163945278957382614824716593",
    d: -2468,
  },
  {
    p: "000001009000580063006000100000853200000209000007000000500000026079000010000064700",
    s: "482631579791582463356497182164853297835279641927146358543718926679325814218964735",
    d: -2767,
  },
  {
    p: "400000000605000208000000400504002010803005000000041890020060040000200970300050600",
    s: "482736159675419238931528467594872316813695724267341895728963541156284973349157682",
    d: -2961,
  },
  {
    p: "400900500000000128160000000008000000043052000000301007037000001900000280001000030",
    s: "482917563379564128165238974518796342743852619296341857837625491954173286621489735",
    d: -2767,
  },
  {
    p: "000209050157000300600000000000000070034002010000000200506000100020068004000407009",
    s: "483219756157846392692735841265391478834672915971584263546923187729168534318457629",
    d: -2767,
  },
  {
    p: "480003900050000000000760000000001070507090003300006218000049001800000302000200046",
    s: "486153927751928634923764185268431579517892463394576218672349851845617392139285746",
    d: -2555,
  },
  {
    p: "000000260000920000300070040000830000000000900715000003270409600640100800090700000",
    s: "487315269156924378329678541964831752832547916715296483271489635643152897598763124",
    d: -2862,
  },
  {
    p: "409050002005000030030014800000060100740200005000000060063008070050003680000040000",
    s: "489356712175892436632714859328569147746281395591437268963128574254973681817645923",
    d: -2468,
  },
  {
    p: "000016200170953864005008900800540009750800000001370050040000083910600002000100000",
    s: "489716235172953864365428917823541679754869321691372458546297183918635742237184596",
    d: -2557,
  },
  {
    p: "090000000000007026000005100008002010107040360560070490800000040000300700700054000",
    s: "491263875385417926672895134948632517127549368563178492859721643214386759736954281",
    d: -2468,
  },
  {
    p: "090060000075000490018700000020000070069008000001350200000002000000089734004000800",
    s: "492561387675823491318794625523946178769218543841357269187432956256189734934675812",
    d: -2468,
  },
  {
    p: "000007130500006000608009270054000000009400000000000780170000320020010000000050900",
    s: "492587136517236849638149275254871693789463512361925784175694328926318457843752961",
    d: -2767,
  },
  {
    p: "000020000000006008000014230000009480006000000340700006608000014020850090001000007",
    s: "493528761512376948867914235175639482286145379349782156638297514724851693951463827",
    d: -2862,
  },
  {
    p: "490001000000370000018050000040080201001040080020000630000209003605000000200000000",
    s: "493821765562374198718956342946783251351642987827195634184269573635417829279538416",
    d: -2767,
  },
  {
    p: "005300020700040930002000400500009700060170000940000300200950000800000002079010000",
    s: "495381627786542931132796485521839764368174259947625318214953876853467192679218543",
    d: -2468,
  },
  {
    p: "090000000200403060085900040658009000000508004000300006007001000020050109003000000",
    s: "496125873271483965385976241658749312132568794749312586967231458824657139513894627",
    d: -2862,
  },
  {
    p: "090100007260708009003000040035070090004000570607000800050200001000035020040010080",
    s: "498153267261748359573926148135872694984361572627594813756289431819435726342617985",
    d: -2745,
  },
  {
    p: "000700010000000409060000080380500000000007090002046801000000005870020004046300900",
    s: "498753216237681459561294783389512647614837592752946831923468175875129364146375928",
    d: -2862,
  },
  {
    p: "014030062000060000000002000876090000003200000045008037300074000008000010000920003",
    s: "514739862782165349639482175876593421193247658245618937351874296928356714467921583",
    d: -2468,
  },
  {
    p: "007002800900580072000730510200910040070000908039070025040029056091060080000000000",
    s: "517492863963581472824736519285913647176254938439678125348129756791365284652847391",
    d: -2557,
  },
  {
    p: "017039000090040500040020016080402000000001800003006200921000008006000300000010000",
    s: "517639482692148537348725916789452163264371895153986274921563748876294351435817629",
    d: -2468,
  },
  {
    p: "500200000040000005300000090006740001000900570007368000070000300000000910400010028",
    s: "519276483742893165368154792926745831834921576157368249271689354685432917493517628",
    d: -2862,
  },
  {
    p: "001090630000005140047000000002400900080001000400000080870000006900306008200509000",
    s: "521894637398765142647213859162458973783921465459637281875142396914376528236589714",
    d: -2468,
  },
  {
    p: "500009006000300009000000740700250000000600015000093800000000200685030004230807000",
    s: "524719386867324159913586742748251693392678415156493827471965238685132974239847561",
    d: -2961,
  },
  {
    p: "024060000081320000930105027009006270005800004000492000008000090100200040040010050",
    s: "524769381781324569936185427419536278265871934873492615358647192197253846642918753",
    d: -2958,
  },
  {
    p: "500800000090000180640020500400008000000040079010000062000000013006500000300600040",
    s: "531876924792453186648921537479268351263145879815397462954782613126534798387619245",
    d: -2767,
  },
  {
    p: "530000000460031900020800410300009000900000260680007000006000000050073690103456080",
    s: "531942876468731925729865413347629158915384267682517349276198534854273691193456782",
    d: -2958,
  },
  {
    p: "030087400000000300060020070005600030800700040002000000080100000004090000370500600",
    s: "531987462927465318468321975745612839813759246692834157286173594154296783379548621",
    d: -2677,
  },
  {
    p: "504200000008563070001000000000080010000000307200950680000000000107000030060010092",
    s: "534271968928563471671849523756384219489126357213957684892735146147692835365418792",
    d: -2862,
  },
  {
    p: "004070080100005903000010500007906000340500670000084002000000008010000700600000100",
    s: "534679281172845963896312547257936814348521679961784352725163498419258736683497125",
    d: -2862,
  },
  {
    p: "504060800700009300600000040000927603000050000000013004009170005810000007300040198",
    s: "534762819721489356698531742145927683283654971976813524469178235812395467357246198",
    d: -2848,
  },
  {
    p: "000000209040002000190000300000000802005016000007004031001400000070800000023090014",
    s: "538167249746932185192548376314759862285316497967284531651473928479821653823695714",
    d: -2862,
  },
  {
    p: "000700000000000009061020540403001200120000000009080000000560003076000090000300408",
    s: "538794612742156839961823547483971256127635984659482371814569723376248195295317468",
    d: -2767,
  },
  {
    p: "039006001060002000008000740000100950700030000105008004301000008000005400000000300",
    s: "539746821467812593218953746823164957746539182195278634351497268672385419984621375",
    d: -2767,
  },
  {
    p: "500000003008700000000040960390060000020901300100250040000070410009000000007006000",
    s: "541692873968735124273148965395467281724981356186253749652379418819524637437816592",
    d: -2767,
  },
  {
    p: "002000700089301004010200000900008600008000907000060003000030010023000560451000000",
    s: "542986731689371254317254896934718625168523947275469183796835412823147569451692378",
    d: -2468,
  },
  {
    p: "006800002080002014000300000704206500001053000000400309400000000052000007000040903",
    s: "546819732389572614217364895734296581891753246625481379463927158952138467178645923",
    d: -2961,
  },
  {
    p: "000260030091000000008047000030100050005400010002803004000008600109000000004000000",
    s: "547261938291385476368947125436179852875426319912853764723598641159634287684712593",
    d: -2677,
  },
  {
    p: "007320080080004030000509200000070000105008000620000004800000006450000072060410000",
    s: "547321689289764531316589247934172865175648923628953714891237456453896172762415398",
    d: -2468,
  },
  {
    p: "540602000608005070002900000070000680000380090000046000000000400000000750230000910",
    s: "547612839698435271312978546173259684426387195859146327781593462964821753235764918",
    d: -2862,
  },
  {
    p: "500000300200403507009010040001000702000800000080000400008170000000069005070200009",
    s: "547692318216483597839517246451936782763824951982751463398175624124369875675248139",
    d: -2862,
  },
  {
    p: "007020001900403050030900000070080203006007000050000080000735400000008000000210090",
    s: "547826931918473652632951847174589263286347519359162784891735426423698175765214398",
    d: -2862,
  },
  {
    p: "001200700000040600307600009000906402700001300950400100680000020130008000009000000",
    s: "561289743298347615347615289813976452724851396956423178685134927132798564479562831",
    d: -2555,
  },
  {
    p: "000000009900006200071000000630008000800300102000059780006070345005000006300002000",
    s: "562783419983416257471295638637128594859347162124659783296871345715934826348562971",
    d: -2961,
  },
  {
    p: "000039002870000410109040000400060000007000083000002000900000000048710300006500000",
    s: "564139872873625419129847536412368957697451283385972641951283764248716395736594128",
    d: -2767,
  },
  {
    p: "060090207102000000900400605700601800010200579200009300005000740000030052600000080",
    s: "564198237172365498983427615739651824416283579258749361395812746847936152621574983",
    d: -2848,
  },
  {
    p: "068002010743000800000005000000000006050001420010060080600200030000406908300007000",
    s: "568742319743619852291385647837524196956871423412963785674298531125436978389157264",
    d: -2468,
  },
  {
    p: "008000000300040006100060000009007005802030704000050293403002800000004009005300000",
    s: "568913427397248516124765938639427185852139764741856293473692851216584379985371642",
    d: -2468,
  },
  {
    p: "069708000000090000028301596007080020300004801800600000000900060600000072971060300",
    s: "569728413134596287728341596457183629396274851812659734245937168683415972971862345",
    d: -2958,
  },
  {
    p: "000236890800000506004000070100005060008000030920300400040090600700600100000783942",
    s: "571236894893417526264859371137945268458162739926378415342591687789624153615783942",
    d: -2958,
  },
  {
    p: "070932000006070210080600005109004060000006000800000027000007603010020000030000050",
    s: "571932846346578219982641735129754368753286491864193527295417683618325974437869152",
    d: -2468,
  },
  {
    p: "070100084009004010000000952040950100308406005000030200700080000210007000000000000",
    s: "572169384839524617164873952647952138328416795951738246793685421215347869486291573",
    d: -2961,
  },
  {
    p: "000300004069000010000040060085030070100000200706008530000004980027183006804070000",
    s: "572316894469857312318942765285431679193765248746298531631524987927183456854679123",
    d: -2848,
  },
  {
    p: "500060090034000002000704600800207005006050000000030009713600000200100000000800700",
    s: "572361894634589172981724653849217365326958417157436289713645928298173546465892731",
    d: -2862,
  },
  {
    p: "000000000010000306000800512040003000000106700091200060009008100425000000006020403",
    s: "572631948814592376963874512647983251258146739391257864739468125425319687186725493",
    d: -2468,
  },
  {
    p: "500080400004000019100006307001690008007008000002300501300000000008400020000001003",
    s: "573189462624735819189246357451692738937518246862374591315927684798463125246851973",
    d: -2468,
  },
  {
    p: "074000900000940203000005074009010705008300000100208000025800069000000047000000000",
    s: "574623918861947253392185674239416785658379421147258396725834169913562847486791532",
    d: -2468,
  },
  {
    p: "000029000603000040000400005402301080000060000185070000800047060000800001201000007",
    s: "574629138613785942928413675462351789397268514185974326859147263736892451241536897",
    d: -2468,
  },
  {
    p: "078000000000654000000800500650008700030500019900002000380200006009100040060000070",
    s: "578329461213654897496871523652918734837546219941732685384297156729165348165483972",
    d: -2468,
  },
  {
    p: "070300241900800000600000030000206500005001008040000006006080075000000000003012000",
    s: "578369241931824657624157839789246513365971428142538796296483175417695382853712964",
    d: -2767,
  },
  {
    p: "000004002002000007109007008006000040020060801000390000005000079340950000000700000",
    s: "578614932432589617169237458956871243723465891814392765285146379347958126691723584",
    d: -2767,
  },
  {
    p: "000004600000000005400000921907200000003005200050009007740006000010030500000070180",
    s: "579124638821693745436857921967281453183745269254369817748516392612938574395472186",
    d: -2862,
  },
  {
    p: "009610000042075060008000400006307004000200000020006000050000300090030071100000002",
    s: "579614823342875169618923457986357214435291786721486935257169348894532671163748592",
    d: -2862,
  },
  {
    p: "080030020000000300000009000900120080002408600850003000400000893030007410000002070",
    s: "581634927279815364364279158943126785712458639856793241427561893635987412198342576",
    d: -2468,
  },
  {
    p: "000000300006834000007900180630090028074000050020000000000000700008007005001205000",
    s: "582176349916834572347952186635791428174628953829543617253489761468317295791265834",
    d: -2862,
  },
  {
    p: "580100020000350090200000031000009400005640000906800000000030600407000000008060000",
    s: "583194726671352894294786531812579463735641289946823175159237648467918352328465917",
    d: -2767,
  },
  {
    p: "000000400069350801007008009608000090000070300005000000050019000401760005000400600",
    s: "583197426269354871147628539678543192914276358325981764756819243431762985892435617",
    d: -2468,
  },
  {
    p: "003000010020580703047002000300008900652049107000000005061005009000900200000710000",
    s: "583497612926581743147632598374158926652349187819276435461825379738964251295713864",
    d: -2745,
  },
  {
    p: "000749600170000000040600038050000013708000050030000204000206490000000000005304000",
    s: "583749621176832549249651738654927813728413956931568274317286495462195387895374162",
    d: -2961,
  },
  {
    p: "000300009000002580200045010009000000800706000000408200000603000000100070050000198",
    s: "584317629137962584296845713349521867812736945765498231971683452428159376653274198",
    d: -2767,
  },
  {
    p: "580900060170035280093060500900000000010376400000140002700000000050080900060000014",
    s: "584927163176435289293861547947258631812376495635149872729614358451783926368592714",
    d: -2848,
  },
  {
    p: "080200094400009000000608275050006001600800000920754080010000700000400150800170060",
    s: "586217394472539816139648275758326941643891527921754683214965738367482159895173462",
    d: -2958,
  },
  {
    p: "080090240000004000009017000120000060400700012703000050001039604000000800000000097",
    s: "587396241612854379349217586128945763456783912793621458871539624964172835235468197",
    d: -2468,
  },
  {
    p: "000460000020008500469000030000000009035040000804100050000609070000234690008005002",
    s: "587463921123978564469521837216357489935842716874196253342689175751234698698715342",
    d: -2648,
  },
  {
    p: "500600000406001030000040050600000000300000290000407001001708000090050680000009003",
    s: "589673124426581937137942856612395478374816295958427361261738549793154682845269713",
    d: -2767,
  },
  {
    p: "000608001080001003070020050900000000607000002230054800000790010000000000000086005",
    s: "592638471486571923173429658958267134647813592231954867824795316365142789719386245",
    d: -2767,
  },
  {
    p: "002061000006000200000005790154680000000900000370040000040100007030009010000000004",
    s: "592761843786394251413825796154687329628913475379542168245136987837459612961278534",
    d: -2767,
  },
  {
    p: "000007410060300050000050309400001008972000004000060900004000000000510080001600000",
    s: "593287416167349852248156379436971528972835164815462937354728691629514783781693245",
    d: -2767,
  },
  {
    p: "004030000000729000070500006020900050009000000360010204000000100210004705086000000",
    s: "594136872638729541172548936421973658859462317367815294945287163213694785786351429",
    d: -2862,
  },
  {
    p: "000073000000950306870000200610000000908405000000000001000700050000094800430006000",
    s: "596273148241958376873641295614327589928415763357869421189732654765194832432586917",
    d: -2767,
  },
  {
    p: "097000028200004900014900070649000000000008050308007000000070089003000200100000000",
    s: "597631428236784915814925376649512837721398654358467192462173589973856241185249763",
    d: -2862,
  },
  {
    p: "000001030002950000000402000870000040034809500200006070005000189000000300000005006",
    s: "597681234342957618618432795876523941134879562259146873725364189461298357983715426",
    d: -2862,
  },
  {
    p: "500000016046090080230050704000087645000005900400030100070002000001000000004501069",
    s: "597824316146793582238156794913287645762415938485639127879362451651948273324571869",
    d: -2848,
  },
  {
    p: "008302004600000200403000560800001039000540026200030070750000001002000000010600050",
    s: "598362714671485293423917568865721439137549826249836175756294381982153647314678952",
    d: -2648,
  },
  {
    p: "602005000000023000043106009000850700000092060109000200000000600000078150050300000",
    s: "612945387598723416743186529264851793375492861189637245427519638936278154851364972",
    d: -2961,
  },
  {
    p: "002000430008006090400800700804592000000700300500010000000100800000004260000025000",
    s: "612957438378246591495831726834592617129768345567413982246179853751384269983625174",
    d: -2862,
  },
  {
    p: "610000082450020000000005100000000003709246000000800706000400010507090030200000000",
    s: "613974582458621379972385164864517923739246851125839746396458217547192638281763495",
    d: -2862,
  },
  {
    p: "000502700003000002900010500540000000700690000080070030001000005005200974400007000",
    s: "614532798853749612927816543549123867732698451186475239271964385365281974498357126",
    d: -2862,
  },
  {
    p: "600500280900200300000004010807009000400670020003000000000020000201847000086100000",
    s: "614593287978261354532784619827319465459678123163452798345926871291847536786135942",
    d: -2468,
  },
  {
    p: "010008050003006000592007000000000013000160000000000074000000097079300006086050000",
    s: "617238459843596721592417368965874213724163985138925674351642897279381546486759132",
    d: -2767,
  },
  {
    p: "600000905008201700904000000509000006000600000730000850090080003402000508000160000",
    s: "617348925358291764924576381549827136281653497736914852195482673462739518873165249",
    d: -2961,
  },
  {
    p: "000300000002009060080000000500001072003062051008500000040980600070004030000030900",
    s: "617358249432719568985246713564891372793462851128573496341985627879624135256137984",
    d: -2862,
  },
  {
    p: "617000095000506007200070631080001000003005000002000073009000004050908000004052710",
    s: "617423895938516247245879631486731952173295468592684173329167584751948326864352719",
    d: -2848,
  },
  {
    p: "000040009809000041030000600500004090076000230090080060700430000100052000000018000",
    s: "617845329859623741234179685528364197476591238391287564785436912143952876962718453",
    d: -2468,
  },
  {
    p: "000007805040600100800000000300470050002009010000030000900002760405000900000016000",
    s: "619327845543698172827154396386471259752869413194235687931542768465783921278916534",
    d: -2767,
  },
  {
    p: "009080070430000006020940105002009000380007060050000000000000000060004901000600287",
    s: "619385472435712896827946135742569318381427569956138724578291643263874951194653287",
    d: -2468,
  },
  {
    p: "020008409500002030703065001805734200000000700000800000000050000460000090000040000",
    s: "621378459589412637743965821895734216214596783376821945938257164467183592152649378",
    d: -2862,
  },
  {
    p: "003700501470010000000000000000004903900067085230859000300900100105000060090500840",
    s: "623748591479215638851693724568124973914367285237859416342986157185472369796531842",
    d: -2848,
  },
  {
    p: "000079540940000200107300000092057800700000000004032675000080400006500700039006100",
    s: "623879541948165237157324986392657814765418392814932675571283469486591723239746158",
    d: -2958,
  },
  {
    p: "003000000081007400500000289000900030405001000000040690706030800200400907050000000",
    s: "623894571981527463574613289862975134495361728317248695746139852238456917159782346",
    d: -2468,
  },
  {
    p: "020000309000200060703640000009053028000006003007090005046925000002000100000000500",
    s: "624571389851239764793648251419753628285416973367892415146925837572384196938167542",
    d: -2555,
  },
  {
    p: "000000800009020010050680004080060090000000000410200087500072000030406901740000000",
    s: "624715839879324516153689724387561492962847153415293687596172348238456971741938265",
    d: -2468,
  },
  {
    p: "000031000000060001057008020070390000230000000060000057000087004000000002900200100",
    s: "624731895398562741157948623471395286235876419869124357512687934783419562946253178",
    d: -2677,
  },
  {
    p: "000000000010006740000800003400070009050310000000000058060000900039000270007580100",
    s: "625743891318956742794821563482675319956318427173492658561237984839164275247589136",
    d: -2767,
  },
  {
    p: "020000010000090000019042000000010090000007806080000050008400902940050007002070003",
    s: "625783419734195628819642375256318794491527836387964251578431962943256187162879543",
    d: -2862,
  },
  {
    p: "600004300040105600097003400982030000000070830003600005806000090000000000079200000",
    s: "625794318348125679197863452982531746564972831713648925856317294231489567479256183",
    d: -2555,
  },
  {
    p: "000005000410700000000000207100000000900024500073680004030060900004090000006000050",
    s: "627815439419732685385946217142357896968124573573689124731568942854293761296471358",
    d: -2677,
  },
  {
    p: "028000000050003806004000010269031000000900000300002000100008500000057023000400900",
    s: "628514379951273846734689215269831754487965132315742698142398567896157423573426981",
    d: -2862,
  },
  {
    p: "600753910090604007005910200006000830000000600900080142100879400080400000200000000",
    s: "628753914391624587475918263516247839842391675937586142153879426789462351264135798",
    d: -2958,
  },
  {
    p: "620000000009003000100680000507009300090000020010475000070024800045700090000098050",
    s: "628957134759143682134682579587269341496831725312475968973524816845716293261398457",
    d: -2648,
  },
  {
    p: "000090002000701400700203000000302016020000040586000300200600008900000100007000069",
    s: "631495782892761453745283691479352816123876945586914327214639578968527134357148269",
    d: -2468,
  },
  {
    p: "000700004000104600082003700010000008060500900700300045800000053020000010000060000",
    s: "631792584957184632482653791215479368364518927798326145876941253529837416143265879",
    d: -2767,
  },
  {
    p: "000097000502000076408026001000300002210400060005060000320900100007000050000001004",
    s: "631897245592134876478526931764318592213459768985762413326945187147283659859671324",
    d: -2555,
  },
  {
    p: "000905040800320009009010503486007000090008714000009000200080030040000020003000080",
    s: "631975248854326179729814563486157392592638714317249856265481937148793625973562481",
    d: -2648,
  },
  {
    p: "602100500000000000050029670000030980060000450800206007523071000010380000000902310",
    s: "632147598798653241154829673271534986369718452845296137523471869916385724487962315",
    d: -2958,
  },
  {
    p: "002009001700000304000800900307005090000000007021000000405700000000000082060308040",
    s: "632479851798651324514832976347165298956283417821947563485726139173594682269318745",
    d: -2767,
  },
  {
    p: "630008509904003000001000038008500000405091000010820000090005004506100702027006000",
    s: "632718549984653271751942638278564913465391827319827456893275164546139782127486395",
    d: -2958,
  },
  {
    p: "632000050005001200000300006020050690008003002400070000000034905060007081904006007",
    s: "632749158745681239819325746327158694198463572456972813271834965563297481984516327",
    d: -2848,
  },
  {
    p: "030005040000000620000006000800003900026400007043900016000007000000100000201040830",
    s: "632895741759314628184726593817263954926451387543978216498537162365182479271649835",
    d: -2862,
  },
  {
    p: "000051007000400063720000490050010000008000050090300000063009002800003601000000004",
    s: "634951827985472163721638495256817349318294756497365218163749582849523671572186934",
    d: -2862,
  },
  {
    p: "600020009009003008002190000020500043007008000806000015500080030010005000000000081",
    s: "635824179179653428482197356921576843357418962846932715594281637718365294263749581",
    d: -2961,
  },
  {
    p: "000050980000000006100700305900070000021000800570080201005000020740000090080000004",
    s: "637451982854293716192768345968172453421536879573984261315849627746325198289617534",
    d: -2862,
  },
  {
    p: "630000000500761000010000700200009083000600000098410000000000300905080410006000807",
    s: "637842591549761238812935746264579183153628974798413625481257369975386412326194857",
    d: -2468,
  },
  {
    p: "000900108001700020094000000010000000000400609000005080000070006700250040800063700",
    s: "637942158581736924294581367416398275358427619972615483129874536763259841845163792",
    d: -2767,
  },
  {
    p: "000000009000608035940010000860000200027403000050100080000020800000070001780900060",
    s: "638245179271698435945317628863759214127483956459162783316524897592876341784931562",
    d: -2468,
  },
  {
    p: "608000000500000408007000000710520600003900007000040020000600000001200850060790340",
    s: "638452179592371468147869235719523684423986517856147923384615792971234856265798341",
    d: -2961,
  },
  {
    p: "030040050000360400420058000000624005500000010007000060000001780006030002700000030",
    s: "639142857875369421421758693198624375562873914347915268253491786986537142714286539",
    d: -2961,
  },
  {
    p: "609010000780090002000000003407000056800070300000500000008904130013765900000000060",
    s: "639412578785693412142857693427139856851276349396548721568924137213765984974381265",
    d: -2648,
  },
  {
    p: "640097080000200901190036002030009000004000007020348000010000070070900004400060800",
    s: "642197583387254961195836742531679428864521397729348156916483275278915634453762819",
    d: -2745,
  },
  {
    p: "600005108010208000870000000000000400001700902200000607380900546164007820009806001",
    s: "642395178915278364873614295796182453451763982238459617387921546164537829529846731",
    d: -2557,
  },
  {
    p: "000010820097000000000036000030061000000090043810007006070000000400002008060008001",
    s: "643519827197284635285736419539461782726895143814327956978153264451672398362948571",
    d: -2767,
  },
  {
    p: "000508907000009003205001000800096000900030580302000000000000708000007360000240000",
    s: "643528917178469253295371846857196432964732581312854679439615728521987364786243195",
    d: -2862,
  },
  {
    p: "000000500000000000090031078061008290000060000730200000004005931000009400000700006",
    s: "643827519187956342592431678461578293925163784738294165274685931856319427319742856",
    d: -2767,
  },
  {
    p: "000003007180520900020060000009000004004310600060807000400000001200000000000602009",
    s: "645193827187524936923768415319256784874319652562847193438975261296431578751682349",
    d: -2767,
  },
  {
    p: "600051000020090300000000100002003000400020080003085092006037000100400000870009000",
    s: "647351829521698347398274165982743651415926783763185492256837914139462578874519236",
    d: -2862,
  },
  {
    p: "640100050003004020002800000060050200000037000000000007809000000107502000000900003",
    s: "648123759513794826972865341761459238284637915395218467859346172137582694426971583",
    d: -2677,
  },
  {
    p: "000002100300405096000000740000300000060000400510000060004910070000076000750020300",
    s: "648792153371485296925631748492367581867159432513248967284913675139576824756824319",
    d: -2862,
  },
  {
    p: "050000070000000506030007001095002067010005043086001020009050002170020000500300094",
    s: "651283479728149536934567281495832167217695843386471925849756312173924658562318794",
    d: -2848,
  },
  {
    p: "002400813000000050000100400004360000090000028301050000080010070240090000060003000",
    s: "652479813418236759739185462874362591596741328321958647983614275245897136167523984",
    d: -2862,
  },
  {
    p: "604001030007630000913087040005000060008706003000100890709400085502978310800000070",
    s: "654291738287634159913587246375829461198746523426153897739412685562978314841365972",
    d: -2890,
  },
  {
    p: "058020790493050800012080000040008072120040683000000009200060930004010067860000014",
    s: "658324791493157826712986345549638172127549683386271459271465938934812567865793214",
    d: -2890,
  },
  {
    p: "059000078320000000007200009760020005000390000000600000190000004000008000000435700",
    s: "659143278328579416417286359761824935845397162932651847193762584574918623286435791",
    d: -2767,
  },
  {
    p: "000000000050706100000120860800500072002070900000060038030000000006052009000980003",
    s: "671498325258736194394125867863519472542873916719264538935647281186352749427981653",
    d: -2468,
  },
  {
    p: "000000100030000078000074200000501083005009010091007452104703020907800300023065090",
    s: "672358149439216578518974236746521983285439617391687452164793825957842361823165794",
    d: -2661,
  },
  {
    p: "600900501305000200090002304960000040007090000000100070000500408000210000800004100",
    s: "672943581345861297198752364961327845287495613534186972716539428459218736823674159",
    d: -2961,
  },
  {
    p: "603008004000706305008001000080002003000070056040000800061020040000040500500000060",
    s: "673258194412796385958431627785962413139874256246315879361527948827649531594183762",
    d: -2468,
  },
  {
    p: "670400010000003095200100700700080001000601000008000920182050007000000200050000004",
    s: "673495812841723695295168743764289531529631478318547926182954367437816259956372184",
    d: -2468,
  },
  {
    p: "600000050050700080009410007810309004000001068000800000040900000201000500700000090",
    s: "674298351152736489389415627815369274423571968967842135548923716291687543736154892",
    d: -2862,
  },
  {
    p: "600000000010040000083000056090001070020000180400000000038509000006020005100004002",
    s: "674395218512648937983712456895231674327456189461987523238569741746123895159874362",
    d: -2767,
  },
  {
    p: "000100030520008000080037020007003400960000001000000570400090018730000000200000000",
    s: "679125834523948167184637925817563492965274381342819576456392718731486259298751643",
    d: -2767,
  },
  {
    p: "670040001030000007000920060000003100000008090051006080010609000020000070085000000",
    s: "679345821532861947148927365894273156763518492251496783417659238326184579985732614",
    d: -2767,
  },
  {
    p: "000835000000002960200040000000000423008000650703000000010900300000003070902018000",
    s: "679835214345172968281649735196587423428391657753426891517964382864253179932718546",
    d: -2862,
  },
  {
    p: "081050300030000106400000980000203608920501000008000000005000803000000765000000010",
    s: "681952374239847156457316982514273698926581437378694521765129843192438765843765219",
    d: -2468,
  },
  {
    p: "003000100040807032200000800005003708006005001000081009020000400001000003090502000",
    s: "683259174149867532257134896915423768836975241472681359728396415561748923394512687",
    d: -2468,
  },
  {
    p: "000000705700000000042003000100000306005030004006509002000640200200080000560200800",
    s: "683914725751862439942753618179428356825136974436579182318645297294387561567291843",
    d: -2862,
  },
  {
    p: "600300002000900050000002608000006340020589006009700080752000100000100004040000000",
    s: "684351972237968451915472638578216349423589716169743285752894163896137524341625897",
    d: -2468,
  },
  {
    p: "684300000000900000003601000100004630060000240040070008802060004005400080006005710",
    s: "684357921751928463293641875127584639568139247349276158812763594975412386436895712",
    d: -2745,
  },
];
